import UserCell from "@/modules/common/components/ui/user-cell";
import { Box, Stack, SxProps, Theme, Tooltip, Typography } from "@mui/material";
import EditIcon from "@/assets/icons/lead-page/edit-icon";
import ResponsiveModal from "@/modules/common/components/ui-kit/modals/responsive-modal";

function LeadAgentEditable({
  name,
  color,
  editable = false,
  handleEdit,
  open,
  onClose,
  title,
  confirmButtonText,
  cancelButtonText,
  onConfirm,
  isLoading,
  isConfirmDisabled,
  snapPoints,
  children,
  sx,
}: Readonly<{
  name?: string;
  color?: string;
  editable?: boolean;
  handleEdit?: () => void;
  open?: boolean;
  onClose: () => void | Promise<void>;
  title?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onConfirm?: () => void | Promise<void>;
  isLoading?: boolean;
  isConfirmDisabled?: boolean;
  snapPoints?: number[];
  children?: React.ReactNode;
  sx?: SxProps<Theme>;
}>) {
  return (
    <Stack
      sx={[
        (t) => ({
          border: `1px solid ${t.nawy.colors.semantic.border.primary}`,
          px: t.nawy.spacing.sm,
          borderRadius: t.nawy.radius.lg,
          height: "100%",
          boxSizing: "border-box",
          justifyContent: "center",
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ minWidth: 0 }}>
        {name ? (
          <Tooltip title={name} placement="top" arrow>
            <Box sx={{ minWidth: 0, overflow: "hidden", flex: 1, "& span": { display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } }}>
              <UserCell name={name} color={color} />
            </Box>
          </Tooltip>
        ) : (
          <Typography
            sx={(t) => ({
              ...t.nawy.typography.english.variants.body.md.regular,
              color: t.nawy.colors.semantic.text.secondary,
            })}
          >
            Unassigned
          </Typography>
        )}
        {editable && (
          <Box
            onClick={handleEdit}
            sx={(t) => ({
              cursor: "pointer",
              color: t.nawy.colors.semantic.text.accent,
              flexShrink: 0,
              display: "flex",
              alignItems: "center",
              "& svg": { width: "12px", height: "12px" },
            })}
          >
            <EditIcon />
          </Box>
        )}
      </Stack>

      {open && (
        <ResponsiveModal
          open={open}
          onClose={onClose}
          title={title}
          confirmButtonText={confirmButtonText}
          cancelButtonText={cancelButtonText}
          onConfirm={onConfirm}
          isLoading={isLoading}
          isConfirmDisabled={isConfirmDisabled}
          snapPoints={snapPoints}
        >
          {children}
        </ResponsiveModal>
      )}
    </Stack>
  );
}

export default LeadAgentEditable;
